import { useMemo, useState } from 'react';

const importScreensOrder = [
  { key: 'course-info', label: 'Info' },
  { key: 'course-schedule', label: 'Schedule' },
  { key: 'course-timeline', label: 'Timeline' },
  { key: 'course-import', label: 'Import' },
  { key: 'course-confirm', label: 'Confirm' },
] as const;
export type CourseImportScreen = 'loading' | typeof importScreensOrder[number]['key'];

const useCourseImportScreen = () => {
  const [activeScreenIndex, setActiveScreenIndex] = useState(-1);

  const activeScreen: CourseImportScreen = useMemo(() => {
    if (activeScreenIndex === -1) return 'loading';
    return importScreensOrder[activeScreenIndex].key;
  }, [activeScreenIndex]);

  const onPrev = () => {
    setActiveScreenIndex((prev) => Math.max(0, prev - 1));
  };

  const onNext = () => {
    setActiveScreenIndex((prev) => Math.min(importScreensOrder.length - 1, prev + 1));
  };

  const goto = (screen: Exclude<CourseImportScreen, 'loading'>) => {
    const screenIndex = importScreensOrder.findIndex((item) => item.key === screen);
    if (screenIndex === -1) return;
    setActiveScreenIndex(screenIndex);
  };

  const gotoIndex = (screenIndex: number) => {
    if (screenIndex < 0) return;
    if (screenIndex > importScreensOrder.length - 1) return;
    setActiveScreenIndex(screenIndex);
  };

  return {
    activeScreen,
    activeScreenIndex,
    onPrev,
    onNext,
    goto,
    gotoIndex,
    totalScreens: importScreensOrder.length,
    screenLabels: importScreensOrder.map((screen) => screen.label),
  };
};

export default useCourseImportScreen;
